import { render, staticRenderFns } from "./tabCustomsInfo.vue?vue&type=template&id=7ed6dc5e&"
import script from "./tabCustomsInfo.vue?vue&type=script&lang=js&"
export * from "./tabCustomsInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ed6dc5e')) {
      api.createRecord('7ed6dc5e', component.options)
    } else {
      api.reload('7ed6dc5e', component.options)
    }
    module.hot.accept("./tabCustomsInfo.vue?vue&type=template&id=7ed6dc5e&", function () {
      api.rerender('7ed6dc5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Job/booking/tabs/tabCustomsInfo.vue"
export default component.exports